import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  onClick,
  href,
  className = ''
}: ButtonProps) {
  const baseStyles = 'font-semibold rounded-full transition-all duration-300 hover:scale-105 hover:shadow-xl';
  const variants = {
    primary: 'bg-gradient-to-r from-emerald-500 to-cyan-500 text-white shadow-lg',
    secondary: 'bg-white text-emerald-600 border-2 border-emerald-500 hover:bg-emerald-50'
  };
  const sizes = {
    sm: 'px-6 py-2 text-sm',
    md: 'px-8 py-3 text-base',
    lg: 'px-10 py-4 text-lg'
  };
  const handleClick = () => {
    if (href) {
      // Track InitiateCheckout event
      if (window.fbq) {
        window.fbq('track', 'InitiateCheckout', {
          content_name: 'Sobrevive a la Quincena',
          content_category: 'Digital Product',
          value: 9.97,
          currency: 'USD'
        });
      }
      // Open in same tab for better conversion
      window.location.href = href;
    } else if (onClick) {
      onClick();
    }
  };
  return <button onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-78">
      {children}
    </button>;
}